import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

export const WINDOW_STEP = 100;

/** Client-side windowing for long in-memory lists: renders `step` rows at a time. */
export function useWindowed(list, step = WINDOW_STEP) {
  const [shown, setShown] = useState(step);
  useEffect(() => { setShown(step); }, [list.length, step]);
  return { items: list.slice(0, shown), hasMore: list.length > shown, showMore: () => setShown((s) => s + step), total: list.length, shown: Math.min(shown, list.length) };
}

export function ShowMoreBar({ win, testid = "show-more", colSpan }) {
  if (!win.hasMore) return null;
  const inner = (
    <div className="flex flex-col items-center gap-1 py-3" data-testid={`${testid}-bar`}>
      <div className="text-[11px] text-slate-500">Showing {win.shown.toLocaleString()} of {win.total.toLocaleString()}</div>
      <button onClick={win.showMore} data-testid={testid} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-4 h-9 text-xs font-semibold text-slate-700 hover:bg-slate-100 transition">
        <ChevronDown className="h-3.5 w-3.5" /> Show {Math.min(WINDOW_STEP, win.total - win.shown)} more
      </button>
    </div>
  );
  return colSpan ? <tr><td colSpan={colSpan}>{inner}</td></tr> : inner;
}
